import { useTranslation } from 'react-i18next';

const stepIcons = [
  'ri-chat-check-line',
  'ri-building-line',
  'ri-file-edit-line',
  'ri-send-plane-line',
  'ri-passport-line',
  'ri-flight-takeoff-line',
];

export default function Process() {
  const { t } = useTranslation('common');
  
  return (
    <section id="process" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            {t('process.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('process.subtitle')}
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {stepIcons.map((icon, index) => (
            <div key={index} className="relative">
              <div className="bg-gradient-to-br from-teal-50 to-white rounded-2xl p-8 shadow-md hover:shadow-xl transition-all duration-300 border border-teal-100 h-full">
                <div className="flex items-start gap-4 mb-6">
                  <div className="text-6xl font-bold text-teal-600/20">
                    {String(index + 1).padStart(2, '0')}
                  </div>
                  <div className="w-14 h-14 bg-teal-600 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className={`${icon} text-2xl text-white w-7 h-7 flex items-center justify-center`}></i>
                  </div>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  {t(`process.steps.${index}.title`)}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {t(`process.steps.${index}.description`)}
                </p>
              </div>
              {index < stepIcons.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-4 w-8 h-0.5 bg-teal-200 z-10"></div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
